import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { GetStockValuesFromDimensionsFragmentFragmentDoc } from '@packages/gql/generated/shopping/GetStockValuesFromDimensionsFragmentFragmentDoc';

/* GraphQL */ `
  fragment GetStockValuesFromDimensionsFragment on Product {
    dimensions {
      type
      values {
        availability {
          state
        }
      }
    }
  }
`;

export type GetStockValuesFromDimensionsProps = FragmentType<
  typeof GetStockValuesFromDimensionsFragmentFragmentDoc
>;

export const getStockValuesFromDimensions = (data: GetStockValuesFromDimensionsProps) => {
  const { dimensions } = getFragmentData(GetStockValuesFromDimensionsFragmentFragmentDoc, data);

  const result: {
    inStock: number;
    outOfStock: number;
  } = {
    inStock: 0,
    outOfStock: 0,
  };

  if (dimensions.length) {
    // filter all input dimensions
    const dimensionsWithoutInput = dimensions.filter((dimension) => dimension?.type !== 'INPUT');

    if (dimensionsWithoutInput.length) {
      // get last dimension
      const lastDimension = dimensionsWithoutInput.pop();

      if (lastDimension) {
        lastDimension.values.forEach((value) => {
          if (value.availability) {
            switch (value.availability.state) {
              case 'NOT_AVAILABLE': {
                result.outOfStock += 1;
                break;
              }
              case 'AVAILABLE':
              case 'NOT_YET_AVAILABLE': {
                result.inStock += 1;
                break;
              }
              default:
                break;
            }
          }
        });
      }
    }
  }
  return result;
};
